import { FC } from "react";
import { useTranslation } from "react-i18next";

import { ContentPanel, PageWrapper } from "@/App/components";
import { NearbyPharmacySearchForm } from "./NearbyPharmacySearchForm";

export const NearbyPharmacyPage: FC = () => {
  const { t: translate } = useTranslation();

  return (
    <PageWrapper>
      <ContentPanel title={translate("NEARBY_PHARMACY.nearbyPharmacyPage.findNearbyPharmacies")}>
        <NearbyPharmacySearchForm />
      </ContentPanel>
    </PageWrapper>
  );
};
